import { render, staticRenderFns } from "./PxCamposCompraItemTableNeoG7.vue?vue&type=template&id=2bb18453&"
import script from "./PxCamposCompraItemTableNeoG7.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemTableNeoG7.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports